import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import './style.css';
import {
  Button, Card, CardHeader, CardTitle, CardBody, CardFooter,
  Form, Input, InputGroupAddon, InputGroupText, InputGroup,
  Container, Col, Row
} from "reactstrap";
import NumberFormat from "react-number-format";
import logo from "assets/img/logo-login.png";
import settings from "settings";
import rotas from "services/rotas";

const Senha = () => {
  const [cpf,     setCpf]     = useState("");
  const [email,   setEmail]   = useState("");
  const [loading, setLoading] = useState(false);
  const [msg,     setMsg]     = useState({ tipo: "", texto: "" });

  useEffect(() => {
    document.body.classList.toggle("login-page");
    return () => {
      document.body.classList.toggle("login-page");
    };
  }, []);

  const solicitar = async (e) => {
    e.preventDefault();
    setMsg({ tipo: "", texto: "" });

    const cpfLimpo = cpf.replace(/\D/g, "");
    if (cpfLimpo.length !== 11) {
      setMsg({ tipo: "erro", texto: "Informe um CPF válido." });
      return;
    }
    if (!email) {
      setMsg({ tipo: "erro", texto: "Informe o email cadastrado." });
      return;
    }

    setLoading(true);
    try {
      const url = settings.url + rotas.senhaSolicitar;
      const ret = await axios.post(url, { cpf: cpfLimpo, email });
      if (ret.data.success === "S") {
        setMsg({ tipo: "ok", texto: ret.data.msg });
        setCpf("");
        setEmail("");
      } else {
        setMsg({ tipo: "erro", texto: ret.data.msg });
      }
    } catch {
      setMsg({ tipo: "erro", texto: "Erro ao conectar com o servidor." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form className="form" onSubmit={solicitar}>
              <Card className="card-login text-center">
                <CardHeader className="text-center p-0">
                  <div className="logo">
                    <div className="logo-img">
                      <img src={logo} alt="WebGestor" style={{ width: "50%" }} />
                    </div>
                  </div>
                  <CardTitle tag="h4">Esqueci a senha</CardTitle>
                </CardHeader>

                <CardBody>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-badge" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <NumberFormat
                      placeholder="CPF"
                      type="text"
                      format="###.###.###-##"
                      mask="_"
                      value={cpf}
                      onValueChange={(v) => setCpf(v.value)}
                      className="form-control"
                    />
                  </InputGroup>

                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-email-85" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Email cadastrado"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </InputGroup>

                  <p style={{ fontSize: "10px", color: "#888" }}>
                    <i>Enviaremos um link para redefinir sua senha. O link expira em 30 minutos.</i>
                  </p>

                  {msg.texto && (
                    <p style={{
                      fontSize: "13px",
                      color: msg.tipo === "ok" ? "#27ae60" : "#e74c3c",
                      fontWeight: 600,
                      margin: "0 0 8px"
                    }}>
                      {msg.texto}
                    </p>
                  )}
                </CardBody>

                <CardFooter>
                  <Button
                    className="btn-round"
                    color="primary"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Enviando..." : "Enviar"}
                  </Button>
                  <br />
                  <Link
                    to="/painelwebgestor/auth/login"
                    style={{ fontSize: "12px", color: "#888", marginTop: "8px", display: "inline-block" }}
                  >
                    Voltar ao login
                  </Link>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
      <div
        className="full-page-background"
        style={{ backgroundImage: `url(${require("assets/img/bg/webgestor_login_bg.jpg")})` }}
      />
    </div>
  );
};

export default Senha;
